var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M14.55 24.444v-9.216M10.161 15.227v9.216M38.68 24.444v-9.216M34.309 15.227v9.216M54.033 29.896H3.71c-1.486 0-2.71-1.22-2.71-2.7 0-1.481 1.224-2.7 2.71-2.7h50.323c5.263 0 9.564-4.269 9.564-9.53a9.522 9.522 0 0 0-5.84-8.78 2.677 2.677 0 0 1-1.434-3.537 2.693 2.693 0 0 1 3.55-1.429A14.934 14.934 0 0 1 69 14.983c0 8.223-6.714 14.913-14.967 14.913Z",
    stroke: "#222",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M51.532 15.227H4.025a3.002 3.002 0 0 1-3.007-2.996 3.002 3.002 0 0 1 3.007-2.997h47.507a3.002 3.002 0 0 1 3.008 2.997 3.002 3.002 0 0 1-3.008 2.996ZM45.708 5.533l-2.954-2.467-2.953 2.467-2.954-2.467-2.954 2.467-2.954-2.467-2.954 2.467-2.953-2.467-2.954 2.467-2.954-2.467-2.954 2.467-2.953-2.467-2.872 2.467L7.39 3.066 4.437 5.533",
    stroke: "#222",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSledge);
export default __webpack_public_path__ + "static/media/sledge.179dbf79.svg";
export { ForwardRef as ReactComponent };